function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import ThemeProvider from "@mui/material/styles/ThemeProvider";
//Limitless imports
import LLMLandingHedaer from "../../components/landing-section-mappers/LLMLandingHeader";
import RadioSelection from "../../components/landing-section-mappers/RadioSelection";
import LLMLandingCTA from "../../components/landing-section-mappers/LLMLandingCTA";
import BasicTextInput from "../../components/landing-section-mappers/BasicTextInput";
import BasicFreeTextInput from "../../components/landing-section-mappers/BasicFreeTextInput";
import BasicText from "../../components/landing-section-mappers/BasicText";
import LandingRichText from "../../components/landing-section-mappers/LandingRichText";
import { modernTheme } from "@limitless/themeing/modern-theme/ModernTheme";
export const SECTION_MAP = {
  "landing-header": LLMLandingHedaer,
  "radio-selection": RadioSelection,
  "radio-selection-with-componentrendering": RadioSelection,
  "landing-cta": LLMLandingCTA,
  "basic-text-input": BasicTextInput,
  "basic-text": BasicText,
  "basic-free-text-input": BasicFreeTextInput,
  "rich-text": LandingRichText
};
export const useStyles = makeStyles(theme => ({
  landingContainer: {
    padding: 30,
    maxWidth: 856
  },
  [theme.breakpoints.up("md")]: {
    landingContainer: {
      padding: 40
    }
  }
}));
const LiveMessengerLandingTemplate = ({
  content,
  themeMode = "light",
  ...rest
}) => {
  var _content$sections;
  const classes = useStyles();
  if (!content || (content === null || content === void 0 ? void 0 : (_content$sections = content.sections) === null || _content$sections === void 0 ? void 0 : _content$sections.length) === 0) {
    return /*#__PURE__*/React.createElement(Grid, {
      container: true,
      className: classes.landingContainer,
      component: Typography
    }, "There has been an error loading this page, please contact support");
  }
  const {
    sections,
    includeContainerSpacing = true
  } = content;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: modernTheme(themeMode)
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: `${includeContainerSpacing ? classes.landingContainer : ""}`
  }, sections.map((section, index) => {
    var _section$defaultRende;
    const Section = SECTION_MAP[section.sectionName];
    const rendering = (_section$defaultRende = section.defaultRendering) !== null && _section$defaultRende !== void 0 ? _section$defaultRende : true;
    if (!Section) {
      return /*#__PURE__*/React.createElement(Typography, null, "Section mapper missing!");
    }
    if (rest.isLLMVisible && !section.showAfterSubmit) {
      return null;
    }
    if (section.sectionName === "radio-selection-with-componentrendering") {
      const {
        values
      } = rest;
      const findChildSection = sections.filter(section => section.category === "componentRendering");
      const value = values[section.stateCaptureKey].value;
      return Object.keys(findChildSection).length > 0 ? findChildSection.map((childSection, i) => {
        const ChildSection = SECTION_MAP[childSection.sectionName];
        (value === "n" || value === "no") && findChildSection.map((childSection, i) => {
          values[childSection.stateCaptureKey] = {
            ...values[childSection.stateCaptureKey],
            value: ""
          };
        });
        (value === "y" || value === "yes") && findChildSection.map((childSection, i) => {
          var _values$childSection$;
          values[childSection.stateCaptureKey] = {
            ...values[childSection.stateCaptureKey],
            value: values[childSection.stateCaptureKey].value !== "" ? values[childSection.stateCaptureKey].value : (_values$childSection$ = values[childSection.stateCaptureKey].addInitialValue) !== null && _values$childSection$ !== void 0 ? _values$childSection$ : ""
          };
        });
        return value === "y" || value === "yes" ? /*#__PURE__*/React.createElement(Grid, {
          key: ""
        }, /*#__PURE__*/React.createElement(Section, _extends({
          key: section.sectionName + index,
          content: section
        }, rest)), /*#__PURE__*/React.createElement(ChildSection, _extends({
          key: childSection.sectionName + index,
          content: childSection
        }, rest))) : /*#__PURE__*/React.createElement(Section, _extends({
          key: section.sectionName + index,
          content: section
        }, rest));
      }) : /*#__PURE__*/React.createElement(Section, _extends({
        key: section.sectionName + index,
        content: section
      }, rest));
    } else {
      return rendering && /*#__PURE__*/React.createElement(Section, _extends({
        key: section.sectionName + index,
        content: section
      }, rest));
    }
  })));
};
export default LiveMessengerLandingTemplate;
LiveMessengerLandingTemplate.propTypes = {
  content: PropTypes.object.isRequired,
  themeMode: PropTypes.string
};